<template>
  <div
    class="receipt-presentation"
    style="text-align: center;margin-left: auto;margin-right: auto;width: 100%;"
  >
    <img
      style="max-width: 100%;max-height: 500px;"
      :src="
        `https://tippiie-images.s3.eu-central-1.amazonaws.com/operaball-payment.jpg?t=${new Date().getTime()}`
      "
    >
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ReceiptPresentation",
  computed: {
    orderNo() {
      return this.paymentInfo.orderNo.split("# ").pop();
    },
    created() {
      return moment(this.paymentInfo.created).format("DD MMM YYYY");
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.receipt-presentation {
  margin: 0 12px;
}
</style>
